import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { useState } from "react";
import { Box, Button } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import DownloadIcon from '@mui/icons-material/Download';
import PaymentsList from "../../features/managePayments/paymentsList";

const ManagePayments = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Payments</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Payments
        </p>
      </div>

      <div className="stats_boxes gap_m">
        <div className="cards">
          <h2>Total Commision Recieved</h2>
          <h3>$2000</h3>
        </div>
      </div>

      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </Box>
          </div>
          <div className="right_s">
            <Button className="btn btn_grey"><DownloadIcon /> Export</Button>
          </div>
        </div>
        <PaymentsList />
      </div>
    </MainContainer>
  );
};

export default ManagePayments;
